// Contract templates for Canntycoon
// Contracts are generated from these templates with randomized parameters within bounds

export const CONTRACT_CHANNELS = {
  wholesale: { label: 'Wholesale', color: '#58a6ff', requiresLicense: 1 },
  medical:   { label: 'Medical',   color: '#3fb950', requiresLicense: 2 },
  retail:    { label: 'Retail',    color: '#d29922', requiresLicense: 3 },
  blackmarket: { label: 'Black Market', color: '#f85149', requiresLicense: 0, illegal: true },
};

// Templates — actual contracts are generated by randomizing within these bounds
export const CONTRACT_TEMPLATES = [
  // ── Wholesale ─────────────────────────────────────────────────────────
  {
    id: 'ws-small',
    channel: 'wholesale',
    label: 'Local Dispensary Supply',
    description: 'A nearby dispensary needs reliable bulk supply. Not picky about strain.',
    minGrams: 80, maxGrams: 150,
    qualityFloor: 40,        // minimum quality score 0-100
    priceMultiplier: 1.0,    // multiplied by base channel price
    durationDays: 14,        // days to fulfill
    penaltyPct: 0.15,        // % of contract value as penalty if missed
    minStage: 1,
    repReward: 2,
    preferredStrains: [],    // empty = any strain
  },
  {
    id: 'ws-medium',
    channel: 'wholesale',
    label: 'Regional Distributor',
    description: 'Bulk order for a regional network. Volume discount price but steady income.',
    minGrams: 200, maxGrams: 400,
    qualityFloor: 45,
    priceMultiplier: 0.95,
    durationDays: 21,
    penaltyPct: 0.20,
    minStage: 1,
    repReward: 4,
    preferredStrains: ['northern-lights', 'bagseed-og'],
  },
  {
    id: 'ws-large',
    channel: 'wholesale',
    label: 'State Distributor Contract',
    description: 'Large recurring order. Meets monthly. Higher volume, lower margin.',
    minGrams: 500, maxGrams: 1000,
    qualityFloor: 50,
    priceMultiplier: 0.90,
    durationDays: 30,
    penaltyPct: 0.25,
    minStage: 2,
    repReward: 8,
    preferredStrains: ['northern-lights'],
  },

  // ── Medical ───────────────────────────────────────────────────────────
  {
    id: 'med-cbd',
    channel: 'medical',
    label: 'CBD Pain Clinic',
    description: 'Pain management clinic needs high-CBD product. Clean COA required.',
    minGrams: 60, maxGrams: 120,
    qualityFloor: 60,
    priceMultiplier: 1.10,
    durationDays: 14,
    penaltyPct: 0.20,
    minStage: 2,
    repReward: 5,
    preferredStrains: ['cbd-harlequin', 'acdc'],
  },
  {
    id: 'med-hospital',
    channel: 'medical',
    label: 'Hospital Formulary',
    description: 'Strict pharmaceutical-grade requirements. Premium prices, zero tolerance for failures.',
    minGrams: 100, maxGrams: 200,
    qualityFloor: 75,
    priceMultiplier: 1.25,
    durationDays: 21,
    penaltyPct: 0.40,       // steep penalty — hospital doesn't mess around
    minStage: 2,
    repReward: 10,
    preferredStrains: ['acdc', 'cbd-harlequin'],
  },
  {
    id: 'med-research',
    channel: 'medical',
    label: 'University Research Study',
    description: 'Academic study needs standardized batch. Pays well, needs documented genetics.',
    minGrams: 50, maxGrams: 100,
    qualityFloor: 70,
    priceMultiplier: 1.35,
    durationDays: 28,
    penaltyPct: 0.30,
    minStage: 2,
    repReward: 7,
    preferredStrains: ['acdc', 'cbd-harlequin', 'northern-lights'],
  },

  // ── Retail ─────────────────────────────────────────────────────────────
  {
    id: 'ret-boutique',
    channel: 'retail',
    label: 'Boutique Dispensary',
    description: 'A premium shop that sells to connoisseurs. High quality floor, top dollar.',
    minGrams: 50, maxGrams: 120,
    qualityFloor: 70,
    priceMultiplier: 1.20,
    durationDays: 14,
    penaltyPct: 0.25,
    minStage: 2,
    repReward: 6,
    preferredStrains: ['wedding-cake', 'zkittlez', 'gorilla-glue-4'],
  },
  {
    id: 'ret-celebrity',
    channel: 'retail',
    label: 'Celebrity Brand Collab',
    description: 'A celebrity brand wants your genetics for a limited drop. Massive rep boost. Demanding.',
    minGrams: 200, maxGrams: 350,
    qualityFloor: 80,
    priceMultiplier: 1.50,
    durationDays: 21,
    penaltyPct: 0.35,
    minStage: 3,
    repReward: 20,
    preferredStrains: ['zkittlez', 'wedding-cake', 'ghost-train-haze'],
  },

  // ── Black Market ────────────────────────────────────────────────────────
  {
    id: 'bm-local',
    channel: 'blackmarket',
    label: 'Anonymous Buyer',
    description: 'Cash in hand. No questions asked. But if you get caught...',
    minGrams: 50, maxGrams: 150,
    qualityFloor: 30,
    priceMultiplier: 1.0,   // multiplied by 14 $/g base
    durationDays: 7,
    penaltyPct: 0.0,        // no financial penalty — legal consequences instead
    minStage: 1,
    repReward: -3,          // reputation hit if discovered
    preferredStrains: ['gorilla-glue-4', 'ghost-train-haze'],
    illegal: true,
  },
  {
    id: 'bm-export',
    channel: 'blackmarket',
    label: 'International Broker',
    description: 'A foreign contact. Enormous payout, enormous risk. One bust ends everything.',
    minGrams: 300, maxGrams: 600,
    qualityFloor: 50,
    priceMultiplier: 1.20,
    durationDays: 10,
    penaltyPct: 0.0,
    minStage: 2,
    repReward: -10,
    preferredStrains: [],
    illegal: true,
  },
];

// Helper to generate a contract instance from a template
let contractIdCounter = 1;
export function generateContract(templateId, gameDay) {
  const template = CONTRACT_TEMPLATES.find(t => t.id === templateId);
  if (!template) return null;
  const gramsRequired = Math.floor(
    template.minGrams + Math.random() * (template.maxGrams - template.minGrams)
  );
  return {
    id: `contract-${contractIdCounter++}`,
    templateId: template.id,
    channel: template.channel,
    label: template.label,
    description: template.description,
    gramsRequired,
    gramsDelivered: 0,
    qualityFloor: template.qualityFloor,
    priceMultiplier: template.priceMultiplier,
    durationDays: template.durationDays,
    deadline: gameDay + template.durationDays,
    penaltyPct: template.penaltyPct,
    status: 'available',    // 'available' | 'active' | 'fulfilled' | 'failed' | 'expired'
    repReward: template.repReward,
    preferredStrains: template.preferredStrains,
    illegal: template.illegal || false,
    createdDay: gameDay,
    acceptedDay: null,
  };
}

// Returns list of available contract templates for a given stage
export function getAvailableTemplates(stage) {
  return CONTRACT_TEMPLATES.filter(t => t.minStage <= stage);
}
